// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_AtualizaUsuariosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /contas/atualiza_usuarios/{conta_id}
 *
 * Updates the users associated with an account.
 * Each item in usuarios_data contains user_id and optionally permissions.
 */
import type { UsuarioPermissoesUpdateNestedInput } from './UsuarioPermissoesUpdateNestedInput'
import { registerContract } from './validate'

export interface Contas_AtualizaUsuariosInput {
usuarios_data: UsuarioPermissoesUpdateNestedInput[]
}

registerContract('Contas_AtualizaUsuariosInput', {
  usuarios_data: {
    type: 'array',
    required: true,
    items: {
      user_id:     { type: 'number',  required: true },
      permissions: { type: 'array',   required: false },
    },
  },
})
